<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-offset-2 is-8">
            <div class="box">
              <h1 class="title">緊急性の編集</h1>
              <div class="field">
                <label class="label">緊急性表示名</label>
                <div class="control">
                  <input class="input" type="text" placeholder="緊急性表示名" v-model="inputForm.name">
                </div>
              </div>
              <div class="field">
                <label class="label">アイコンイメージ</label>
                <div>
                  <img :src="inputForm.img_path" alt="アイコンイメージ" v-if="inputForm" width="64" height="64">
                </div>
                <input type="button" class="button is-link" value="アイコン表示" @click="iconShowModal = true">
              </div>
              <button class="button is-link" v-on:click="update">確 定</button>
              &nbsp;&nbsp;
              <button v-if="inputForm.deleted_at === '1'" class="button is-danger" v-on:click="disable">無効にする</button>
              <button v-else class="button is-primary" v-on:click="enable">有効にする</button>
              &nbsp;&nbsp;
              <router-link to="/settings/urgency">
                <span class="button is-primary">
                  <span class="icon"><i class="fa fa-backward"></i></span>&nbsp;&nbsp;戻 る
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <transition name="modal" v-if="iconShowModal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header">
                <slot name="header">
                  アイコンの選択
                </slot>
              </div>
              <div class="modal-body">
                <slot name="body">
                  <div class="columns is-gapless is-multiline is-mobile">
                    <div class="column is-one-quarter" v-for="img_src in hokokuArray" v-bind:key="img_src">
                      <img :src="img_src" class="img_link" alt="アコンイメージ" @click="select_img(img_src)">
                    </div>
                  </div>
                  <div class="columns is-gapless is-multiline is-mobile">
                    <div class="column is-one-quarter" v-for="img_src in mituketaArray" v-bind:key="img_src">
                      <img :src="img_src" class="img_link" alt="アコンイメージ" @click="select_img(img_src)">
                    </div>
                  </div>
                  <div class="columns is-gapless is-multiline is-mobile">
                    <div class="column is-one-quarter" v-for="img_src in saigaiArray" v-bind:key="img_src">
                      <img :src="img_src" class="img_link" alt="アコンイメージ" @click="select_img(img_src)">
                    </div>
                  </div>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data: function() {
    return {
      inputForm: {
        name: '',
        deleted_at: 0,
      },
      iconShowModal: false,
      hokokuArray:[
        "static/hokoku_blue.svg",
        "static/hokoku_pink.svg",
        "static/hokoku_red.svg",
        "static/hokoku_yellow.svg",
      ],
      mituketaArray:[
        "static/mitsuketa_blue.svg",
        "static/mitsuketa_red.svg",
        "static/mitsuketa_yellow.svg",
      ],
      saigaiArray:[
        "static/saigai_black.svg",
        "static/saigai_white.svg",
        "static/saigai_yellow.svg",
      ],
    }
  },
  computed:{
    ...mapGetters({
      getUrgency: 'item/getUrgency'
    }),
    ...mapState({
      apiStatus: state => state.item.apiStatus
    })
  },
  mounted (){
    this.$set(this, 'inputForm', this.getUrgency(this.$route.params.urgencyId))
  },
  methods: {
    select_img (path){
      this.$set(this.inputForm, 'img_path', path)
      this.iconShowModal = false
    },
    async update () {
      if(this.inputForm.name ===""){
        this.$swal({
          title: '確認',
          text: '緊急性表示名を入力してください。',
          icon: 'error',
          confirmButtonText: '戻る',
        })
        return false
      }
      await this.$store.dispatch('item/updateUrgency', this.inputForm)
      if(this.apiStatus){
        this.$swal({
          position: 'top-end',
          icon: 'success',
          title: 'データを更新しました。',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    disable() {
      this.$set(this.inputForm, 'deleted_at', '0')
      this.update()
    },
    enable() {
      this.$set(this.inputForm, 'deleted_at', '1')
      this.update()
    }
  }
}
</script>